var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdyniaApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.463,
    height: 23,
    viewBox: "0 0 39.463 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M845.4,340.612h-3.745l-7.354,7.48a6.535,6.535,0,0,1,.11,1.509,11.89,11.89,0,0,1-3.305,8.417,10.824,10.824,0,0,1-7.972,3.211,11.49,11.49,0,1,1,8.124-19.616q.068.063.141.141l-5.154,5.133q-.068-.079-.131-.141-.141-.141-.288-.262a4.056,4.056,0,0,0-2.692-.964,4.214,4.214,0,1,0,2.98,7.2,4.966,4.966,0,0,0,.623-.78h-3.593V349.59h6.406q.01.22,0,.45a1.373,1.373,0,0,1-.01.173v.068q-.01.084-.021.173a6.424,6.424,0,1,1-6.385-7.124,6.329,6.329,0,0,1,2.792.613l2.038-2.038a9.169,9.169,0,1,0,1.566,14.493,9.587,9.587,0,0,0,2.692-6.2h-.01a10.785,10.785,0,0,0-.22-2.1,8.533,8.533,0,0,0-.22-.843l8.889-9h10.413L837.6,351.822l5.406,7.077h3.373l-5.416-7.181,1.739-1.5,8.407,11.036h-9.261l-7.323-9.764Z",
    transform: "translate(-811.65 -338.25)",
    fill: "#5FB4D9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdyniaApp);
export default __webpack_public_path__ + "static/media/gdynia-app.3ae1c6f11949052a461cd728791a7286.svg";
export { ForwardRef as ReactComponent };